import apiClient from '@/lib/api/client'

export type GeographicOption = {
  id: number
  code?: string
  label: string
  name?: string
}

function normalizeOptions(payload: unknown): GeographicOption[] {
  if (Array.isArray(payload)) return payload as GeographicOption[]
  if (payload && typeof payload === 'object' && Array.isArray((payload as { data?: unknown }).data)) {
    return (payload as { data: GeographicOption[] }).data
  }
  return []
}

export const geographicService = {
  async getRegions(): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/regions')
    return normalizeOptions(data)
  },

  async getProvinces(regionId: number): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/provinces', {
      params: { region_id: regionId },
    })
    return normalizeOptions(data)
  },

  async getTowns(provinceId: number): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/towns', {
      params: { province_id: provinceId },
    })
    return normalizeOptions(data)
  },
}
